import React from 'react';
import { SettingsFlag } from '../../../preferences/components/SettingsFlag';
import useSpotConfig from '@host-panel/request/config/use-config';
import { useTypedSelector } from 'state';
import { useSendEvent } from '../../../../tracking/useSendEvent';
import { createSettingsChangedPayload } from '../settings-send-event-utils';
import { useDispatch } from 'react-redux';
import {
  INAPPROPRIATE_USERNAME_MODEL,
  OW_MODEL_PREFIX
} from '../../../settings/policy/moderation-filters/moderation-filters/moderationFiltersConstants';
import { setUsernameModeration } from '../../../../../setiings/policy/policyFlagsSlice';

const NAME_VALIDATION_KEY = 'tenant.moderation.name_validation';
const ANALYZER_MODELS_KEY = 'tenant.moderation-ml.ow_analyzer_models';

export function UsernameModeration() {
  const { dataScienceModelMap, models } = useTypedSelector(
    state => state.settings.policy.moderationFilters
  );
  const { sendEvent } = useSendEvent();
  const [, setConfigs] = useSpotConfig();
  const dispatch = useDispatch();

  const onChange = (value: boolean) => {
    const dsModelName = dataScienceModelMap[INAPPROPRIATE_USERNAME_MODEL];
    const textModels = Object.entries(models).reduce<Record<string, string>>(
      (acc, [key, model]) => {
        if (key.startsWith(OW_MODEL_PREFIX) && model.value !== null) {
          acc[key] = dataScienceModelMap[key];
        }

        return acc;
      },
      {}
    );

    const resultModels =
      value && dsModelName
        ? { ...textModels, [INAPPROPRIATE_USERNAME_MODEL]: dsModelName }
        : textModels;

    setConfigs(
      [
        {
          key: NAME_VALIDATION_KEY,
          value
        },
        {
          key: ANALYZER_MODELS_KEY,
          value: resultModels
        }
      ],
      undefined,
      (isSuccess: boolean) => {
        sendEvent(
          createSettingsChangedPayload('Username and Display Name Moderation', value, {
            be_success: isSuccess
          })
        );

        if (isSuccess) {
          dispatch(setUsernameModeration(value));
        }
      }
    );
  };

  const onFetched = (value: boolean) => {
    dispatch(setUsernameModeration(value));
  };

  return (
    <SettingsFlag
      title="Username and Display Name Moderation"
      description="Users trying to register or edit their names with inappropriate choices will be prompted to change before proceeding."
      path={NAME_VALIDATION_KEY}
      onChange={onChange}
      onFetched={onFetched}
    />
  );
}
